import { render, staticRenderFns } from "./attributesPopover.vue?vue&type=template&id=bff4789e&scoped=true&"
import script from "./attributesPopover.vue?vue&type=script&lang=js&"
export * from "./attributesPopover.vue?vue&type=script&lang=js&"
import style0 from "./attributesPopover.vue?vue&type=style&index=0&id=bff4789e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff4789e",
  null
  
)

export default component.exports